import apiClient from './apiClient';

export async function fetchDashboardSummary() {
  const { data } = await apiClient.get('/dashboard/summary');
  return data;
}


export async function fetchSecurityScore() {
  const { data } = await apiClient.get('/dashboard/security-score');
  return data;
}

export async function fetchSeverityBreakdown() {
  const { data } = await apiClient.get('/dashboard/severity-breakdown');
  return data;
}

export async function fetchThreatTimeline() {
  const { data } = await apiClient.get('/dashboard/threat-timeline');
  return data;
}

export async function fetchActiveIncidentsSummary() {
  const { data } = await apiClient.get('/dashboard/incidents');
  return data;
}

export async function fetchLiveFeed(count = 40) {
  const { data } = await apiClient.get('/dashboard/live-feed', { params: { count } });
  return data;
}
